import { store } from "@/stores/store";

/**
 * Logged-in user id, or null when unknown. Read from the auth slice
 * (`currentUser` is either the user or a `{ user, ... }` session wrapper),
 * falling back to the persisted `xale_current_user`. Never read
 * `xale_user_id` — the app does not write that key.
 */
export function currentUserId(): number | null {
  const idOf = (stored: unknown): number | null => {
    if (!stored || typeof stored !== "object") return null;
    const wrapper = stored as { user?: unknown; id?: unknown };
    const user = (
      wrapper.user !== undefined ? wrapper.user : wrapper
    ) as { id?: unknown } | null;
    const id = Number(user?.id);
    return Number.isFinite(id) && id > 0 ? id : null;
  };
  try {
    const fromStore = idOf(store.getState().auth?.currentUser);
    if (fromStore != null) return fromStore;
    const raw = localStorage.getItem("xale_current_user");
    return raw ? idOf(JSON.parse(raw)) : null;
  } catch {
    return null;
  }
}
